module.exports = __webpack_public_path__ + "img/83c481f8469c4e9ca6929c1d3c5b015e.112a14d5.png";